import type { SxProps, Theme } from "@mui/material";

/** Muted chip look shared by active filter chips and the predefined filters waiting to be applied. */
export const filterChipSx: SxProps<Theme> = {
  bgcolor: "rgba(0,0,0,0.06)",
  color: "text.secondary",
  fontWeight: 500,
  "& .MuiChip-deleteIcon": { color: "text.disabled", "&:hover": { color: "text.secondary" } },
};
